<header fxLayoutAlign="center center" fxLayout="row wrap" name="headerNavigationBar" id="main-header">
  <mat-toolbar color="primary" class="mat-elevation-z8">
    <div fxHide.gt-sm>
      <button mat-icon-button (click)="onToggleSidenav()" id="btnMenuSideNav">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="5px">
      <h1 fxHide.gt-sm>WEST</h1>
      <img fxHide.lt-md class="logo" title="WEST" alt="Wales Essential Skills Toolkit" routerLink="/welcome">

      <button i18n="@@button-home" name="button-home" id="btnHome" fxHide.lt-md
        [routerLink]="loginDisplay ? ['/dashboard'] : ['/welcome']" mat-button>Home</button>
      <mat-list-item fxHide.lt-md name="button-menu-information" [matMenuTriggerFor]="menu" *ngIf=loginDisplay>
        <button i18n="@@button-information" name="button-information" id="btnInformation" mat-button>Information</button>
      </mat-list-item>
      <mat-menu name="information-menu" #menu="matMenu">
        <button *ngIf="informationHeader.hdiw" i18n="@@button-info-how" name="button-info-how" id="btnInfoHow" mat-menu-item
          routerLink="how-does-it-work" routerLinkActive="active-link"
          (click)="onSidenavClose()">How
          does it work?</button>
        <button *ngIf="informationHeader.learnerGuide" i18n="@@button-info-learner-guide" name="button-info-learner-guide" id="btnInfoLearnerGuide" mat-menu-item
          routerLink="learner-guide" routerLinkActive="active-link"
          (click)="onSidenavClose()">Learner Guide</button>
        <button *ngIf="informationHeader.faq" i18n="@@button-info-faq" name="button-info-faq" id="btnInfoFaq" mat-menu-item
          routerLink="faq" routerLinkActive="active-link">FAQs</button>
        <button *ngIf="informationHeader.tutorResources" i18n="@@button-info-tutor" name="button-info-tutor" id="btnInfoTutor" mat-menu-item
          routerLink="tutor-resources" routerLinkActive="active-link" (click)="onSidenavClose()">Tutor Resources</button>
        <button *ngIf="informationHeader.offlineTool && isDevEnvironment" i18n="@@button-info-download" name="button-info-download" id="btnInfoDownload" mat-menu-item
          (click)="onSidenavClose()">Download the WEST Offline Assessment Tool</button>
        <button *ngIf="informationHeader.externalAssessment && isDevEnvironment" i18n="@@button-info-enter" name="button-info-enter" id="btnInfoEnter" mat-menu-item
          (click)="onSidenavClose()">Enter external assessment results</button>
        <button *ngIf="informationHeader.transferLearning && isDevEnvironment" i18n="@@button-info-transfer" name="button-info-transfer" id="btnInfoTransfer" mat-menu-item
          (click)="onSidenavClose()">Transfer learning from previous provider</button>
        <button *ngIf="informationHeader.misAgentTool && isDevEnvironment" i18n="@@button-info-agent" name="button-info-agent" id="btnInfoAgent" mat-menu-item
          (click)="onSidenavClose()">WEST
          MIS Agent Tool</button>
      </mat-menu>
    </div>
    <div fxFlex fxLayout fxLayoutAlign="end center" fxLayoutGap="5px">
      <ng-container>
        <button id="btnLanguage" *ngIf="scormContentNotExist" mat-button (click)="changeLanguage()">{{siteLanguageCode
          === 'cy' ? 'English' :
          'Welsh'}}</button>
        <button id="btnAvatarMenu" [matMenuTriggerFor]="profileMenu" #menuTrigger="matMenuTrigger" *ngIf=loginDisplay
          mat-icon-button [ngClass]="{'avatarMenuToggled' : menuTrigger.menuOpen == true}">
          <mat-icon>person</mat-icon>
        </button>
      </ng-container>
      <mat-menu #profileMenu="matMenu" class="avatarMatMenuPanelClass">
        <button id="btnProfileMenuUserInfo" class="menuButtonUserInfo" mat-menu-item>
          <h3 name="userFullname" class="menuButtonUserFullName"><b>{{userDetail?.completeName}}</b></h3>
          <small name="userEmail" class="menuButtonUserEmail">{{userDetail?.email}}</small>
        </button>
        <mat-divider></mat-divider>
        <button i18n="@@profile-menu-button-dashboard" name="profile-menu-button-dashboard" id="btnProfileMenuDashboard"
          class="buttonMenuHeight" [routerLink]="loginDisplay ? ['/dashboard'] : ['/welcome']"
          mat-menu-item>Dashboard</button>
        <button i18n="@@profile-menu-button-update-profile" name="profile-menu-button-update-profile"
          id="btnProfileMenuUpdateProfile" class="buttonMenuHeight" routerLink="/update-userprofile"
          mat-menu-item>Update Profile</button>
        <button i18n="@@profile-menu-button-change-password" name="profile-menu-button-change-password"
          id="btnProfileMenuChangePassword" class="buttonMenuHeight" (click)="changePassword()" mat-menu-item>Change
          Password</button>
        <mat-divider></mat-divider>
        <button i18n="@@button-logout" name="button-logout" id="btnLogout" mat-menu-item (click)="logout()">Log
          out</button>
      </mat-menu>
    </div>
  </mat-toolbar>
</header>